// utils/cleanQuillHtml.js
export function cleanQuillHtml(html = "") {
  return html
    // hapus paragraf kosong di akhir
    .replace(/(<p><br><\/p>)+$/g, "")
    // hapus paragraf kosong beruntun
    .replace(/(<p><br><\/p>){2,}/g, "<p><br></p>")
    .trim();
}
